"use client"

import { useEffect, useRef, useState } from 'react'
import SvgIcon from '@components/shared/svg-icons/SvgIcon'
import mix from '@utils/styles/mix'

import styles from './Messages.module.css'

// Okno: otwierane przy montowaniu (fokus na focusRef, jeśli podany), Esc i klik w tło zamykają, fokus wraca na element,
// z którego otwarto.
export function useDialog (onClose, opener, focusRef) {
    const ref = useRef(null)
    const down = useRef(false)
    useEffect(() => {
        const d = ref.current
        if (d && !d.open) d.showModal()
        focusRef?.current?.focus()
        return () => { if (opener?.isConnected) setTimeout(() => opener.focus(), 0) }
    }, [])
    const props = {
        ref,
        onClose,
        onCancel: (e) => { e.preventDefault(); onClose() },
        onPointerDown: (e) => { down.current = e.target === ref.current },
        onClick: (e) => { if (down.current && e.target === ref.current) onClose(); down.current = false },
    }
    return props
}

export function DialogHead ({ id, title, onClose }) {
    return (
        <div className={styles.dHead}>
            <h2 id={id}>{title}</h2>
            <button aria-label="Zamknij" className={styles.iconBtn} onClick={onClose} type="button"><SvgIcon name="close" /></button>
        </div>
    )
}

const REASONS = [
    ['spam', 'Spam lub reklama'],
    ['fraud', 'Próba oszustwa', 'np. prośba o zapłatę z góry, link do płatności'],
    ['abuse', 'Obraźliwe treści'],
    ['other', 'Inny powód'],
]

export function ReportDialog ({ opener, onClose, onSubmit }) {
    const dialog = useDialog(onClose, opener)
    const [busy, setBusy] = useState(false)
    const submit = async (e) => {
        e.preventDefault()
        const f = new FormData(e.currentTarget)
        setBusy(true)
        const done = await onSubmit({ reason: f.get('reason'), text: f.get('text'), block: f.get('block') === 'on' })
        setBusy(false)
        if (done) onClose()
    }
    return (
        <dialog aria-labelledby="report-h" className={styles.dialog} {...dialog}>
            <DialogHead id="report-h" onClose={onClose} title="Zgłoś rozmowę" />
            <form className={styles.dBody} onSubmit={submit}>
                <p>Zgłoszenie trafi do zespołu Samochody.pl razem z treścią rozmowy. Druga strona nie dowie się, kto zgłosił.</p>
                <fieldset className={styles.fieldset}>
                    <legend className={styles.legend}>Powód</legend>
                    { REASONS.map(([value, label, hint], i) => (
                        <label className={styles.opt} key={value}>
                            <input defaultChecked={i === 0} name="reason" type="radio" value={value} />
                            <span><b>{label}</b>{ hint && <small>{hint}</small> }</span>
                        </label>
                    )) }
                </fieldset>
                <div className={styles.field}>
                    <label htmlFor="report-text">Opis <span className={styles.req}>(opcjonalnie)</span></label>
                    <textarea className={styles.control} id="report-text" maxLength={1000} name="text" />
                </div>
                <label className={styles.check}><input name="block" type="checkbox" />Zablokuj też tego użytkownika</label>
                <div className={styles.dActs}>
                    <button className={mix([styles.btn, styles.secondary])} onClick={onClose} type="button">Anuluj</button>
                    <button className={mix([styles.btn, styles.primary])} disabled={busy} type="submit">Wyślij zgłoszenie</button>
                </div>
            </form>
        </dialog>
    )
}

export function BlockDialog ({ name, opener, onClose, onConfirm }) {
    const dialog = useDialog(onClose, opener)
    return (
        <dialog aria-labelledby="block-h" className={styles.dialog} {...dialog}>
            <DialogHead id="block-h" onClose={onClose} title="Zablokować użytkownika?" />
            <div className={styles.dBody}>
                <p>{name} nie będzie mógł do Ciebie pisać — ani w tej, ani w nowych rozmowach. Możesz to cofnąć w każdej chwili.</p>
                <div className={styles.dActs}>
                    <button className={mix([styles.btn, styles.secondary])} onClick={onClose} type="button">Anuluj</button>
                    <button className={mix([styles.btn, styles.danger])} onClick={() => { onClose(); onConfirm() }} type="button">Zablokuj</button>
                </div>
            </div>
        </dialog>
    )
}
